import { Injectable } from '@angular/core';
import {
  MsalGuardConfiguration,
  MsalInterceptorConfiguration,
} from '@azure/msal-angular';
import {
  BrowserCacheLocation,
  IPublicClientApplication,
  InteractionType,
  LogLevel,
  PublicClientApplication,
} from '@azure/msal-browser';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
/**
 * Provides factories for MSAL instance, interceptor config, and route guards
 * These are intended to be used at the module level
 */
export class MsalFactoryService {
  interactionType: InteractionType.Redirect = InteractionType.Redirect;
  isIE: boolean;
  constructor() {
    this.isIE =
      window.navigator.userAgent.indexOf('MSIE ') > -1 ||
      window.navigator.userAgent.indexOf('Trident/') > -1; // Remove this line to use Angular Universal
  }

  public loggerCallback(logLevel: LogLevel, message: string): any {
    switch (logLevel) {
      case 0:
        console.error(message);
        break;
      case 1:
        console.warn(message);
        break;
      case 2:
        console.info(message);
        break;
      case 3:
        console.debug(message);
        break;
      case 4:
        console.debug(message);
        break;
      default:
        break;
    }
  }



  public MsalInstanceFactory(): IPublicClientApplication {
    const config: any = environment;
    const loggerCallback = this.loggerCallback;
    return new PublicClientApplication({
      auth: {
        clientId: config['azure_client_id'],
        authority: `https://login.microsoftonline.com/${config['azure_tenant']}`, // Duke tenant id
        // when using redirect login a redirectUri is required
        redirectUri: config['azure_redirect_uri'], //
        postLogoutRedirectUri: '/',
      },
      cache: {
        cacheLocation: BrowserCacheLocation.LocalStorage,
        storeAuthStateInCookie: this.isIE, // set to true for IE 11. Remove this line to use Angular Universal
      },
      system: {
        loggerOptions: {
          loggerCallback,
          logLevel: LogLevel.Warning,
          piiLoggingEnabled: false,
        },
      },
    });
  }

  public MsalInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    let config: any = environment;
    protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', [
      'user.read',
    ]); // Required for authentication
    protectedResourceMap.set(config['api'], config['api_role']); // For AWS API
    return {
      interactionType: this.interactionType,
      protectedResourceMap,
    };
  }

  public MsalGuardConfigFactory(): MsalGuardConfiguration {
    return {
      interactionType: this.interactionType,
      authRequest: {
        scopes: ['user.read'],
      },
      loginFailedRoute: '/not-authorized',
    };
  }
}
